import styled from "styled-components";

import { ContainerInterface, RadioButtonInterface } from "./interfaces";

import colors from "../../../assets/css/colors";


export const DivForm = styled.div`
    display: ${(p: ContainerInterface) => p.isAddFormVisible ? "flex" : "none"};
    border-left-style: solid;
    border-left-width: 1px;
    border-left-color: ${colors.grayDark};

    @media (max-width: 600px) {
        width: 100%;
        border: none;
    }
`
export const Legend = styled.legend`
    margin-top: 41px;
    margin-bottom: 17px;
    color: ${colors.tertiary};
    font-size: 13px;
`;

export const THead = styled.thead`
  background: ${colors.grayLight} 0% 0% no-repeat padding-box;
  height: 34px;
  opacity: 1;
`;

export const Th = styled.th`
  font-family: muli, sans-serif;
  font-weight: 800;
  font-style: normal;
  color: ${colors.grayDark};
  text-align: center;
  letter-spacing: 0px;
  opacity: 1;
  text-transform: uppercase;
`;

export const ThFilterable = styled.th`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  font-family: muli, sans-serif;
  font-weight: 800;
  font-style: normal;
  color: ${colors.grayDark};
  text-align: center;
  letter-spacing: 0px;
  opacity: 1;
  text-transform: uppercase;
`

export const Td = styled.td`
  font-family: muli, sans-serif;
  font-weight: 300;
  font-size: normal;
  color: ${colors.blackLight};
  text-align: center;
  vertical-align: middle !important;
  letter-spacing: 0px;
  opacity: 1;
  text-transform: uppercase;
`;

export const Select = styled.select`
    width:100%;
    height: 31px;
    margin-bottom: 23px;
    background: ${colors.white};
    color: ${colors.tertiary};
    border-radius: 7px;
    border: 1px solid rgba(194, 194, 194, 0.2);
    font-size: 0.8em;
    font-weight: 300;
    line-height: 1.45;
    outline: none;
    padding: 0.4em 1em 0.4em;
    -webkit-transition: 0.18s ease-out;
    -moz-transition: 0.18s ease-out;
    -o-transition: 0.18s ease-out;
    transition: 0.18s ease-out;

    -webkit-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    -moz-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);

    &:hover {
        border: 1px solid rgba(255, 169, 89, 0.2);
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }

    &:focus {
        color: var(--gray);
        border: 1px solid ${colors.secondaryDark};
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }

    &:disabled {
        background-color: ${colors.grayLightest};
    }

    &::-webkit-input-placeholder {
        /* WebKit browsers */
        text-transform: none;
    }
    &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        text-transform: none;
    }
    &::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        text-transform: none;
    }
    &:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        text-transform: none;
    }
    &::placeholder {
        /* Recent browsers */
        text-transform: none;
    }
`;

export const FormRadioButtonContainer = styled.div`
    display: flex;
    align-items: flex-start;
    height: 13px;
    font: normal normal 300 10px/13px Muli;
    color: ${colors.gray};
    margin-right: 25px;
`;

export const FormRadioButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 10px;
    height: 10px;
    border: 1px solid ${colors.primary};
    border-radius: 5px;
    margin-right: 10px;
`;

export const FormRadioButtonContent = styled.div`
    width: 6px;
    height: 6px;
    background-color: ${(p: RadioButtonInterface) => p.isPrimary ? colors.primary : "transparent"};
    border-radius: 5px;
`;

export const InputWithHintContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 23px;
`;
